"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SwiperPlug = __importStar(require("swiper/react"));
var storybook_1 = require("@eyecons/storybook");
var react_1 = __importDefault(require("react"));
var breakpoints = {
    "0": {
        "slidesPerView": 1.5,
        "slidesPerGroup": 1.5,
    },
    "768": {
        "slidesPerView": 3.5,
        "slidesPerGroup": 3.5,
    }
};
function LiveVideos(_a) {
    var livestreams = _a.livestreams;
    return react_1.default.createElement(storybook_1.Layouts.Swiper, { spaceBetween: 3.5, breakpoints: breakpoints, className: 'storybook-home-live-videos' }, livestreams.data.map(function (stream, index) {
        return react_1.default.createElement(SwiperPlug.SwiperSlide, { key: index },
            react_1.default.createElement(storybook_1.Videos.CardLive, { video: stream }));
    }));
}
exports.default = LiveVideos;
